var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getListIndoorMapsUrl, getConfigurationUrl, getCollectionsUrl, getLayersUrl, getDraftsUrl, getCatalogUrl, getBlobStoreUrl, getMetaDataUrl, } from "./platform";
import axios from "axios";
import { setIsLoaded, setIsMapAPICalled, setIsNoMap, setStepIndex, } from "../store/reducers/appSlice";
import { axiosGetAPI, formatVenueList } from "./app";
/**
 * method to get the list of maps present in the realm
 * @param token {string} - authorization token
 * @param dispatch - to set the value of IsNoMap
 * @returns - response data
 */
export var listIndoorMaps = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var listUrl, token, response, res, err_1;
    var _a, _b, _c, _d, _e, _f, _g;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                listUrl = getListIndoorMapsUrl();
                token = (_a = getState()) === null || _a === void 0 ? void 0 : _a.user.token;
                _h.label = 1;
            case 1:
                _h.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.get(listUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 2:
                response = _h.sent();
                res = (response === null || response === void 0 ? void 0 : response.data.data) || null;
                if (((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.length) === 0) {
                    res = null;
                }
                dispatch(setIsMapAPICalled(true));
                dispatch(setIsNoMap(!res));
                dispatch(formatVenueList(res));
                return [3 /*break*/, 4];
            case 3:
                err_1 = _h.sent();
                if (((_e = (_d = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.status) === 400 ||
                    ((_g = (_f = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.status) === 404) {
                    dispatch(setIsNoMap(true));
                }
                // if call fails show loader
                dispatch(setIsLoaded(false));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
/**
 * method to get realm configuration details
 * @param usertoken {string} - user token
 * @returns - response data
 */
export var getConfigurationDetails = function (usertoken) { return __awaiter(void 0, void 0, void 0, function () {
    var configurationUrl, response, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                configurationUrl = getConfigurationUrl();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.get(configurationUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(usertoken),
                        },
                    })];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response || null];
            case 3:
                err_2 = _a.sent();
                return [2 /*return*/, Promise.reject(err_2)];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * method to setup realm configuration
 * @param usertoken {string} - user token
 * @returns - response data
 */
export var postConfigurationDetails = function (usertoken) { return __awaiter(void 0, void 0, void 0, function () {
    var configurationUrl, response, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                configurationUrl = getConfigurationUrl();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.post(configurationUrl, {}, {
                        headers: {
                            Authorization: "Bearer ".concat(usertoken),
                            "Content-Type": "application/json",
                        },
                    })];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response || null];
            case 3:
                err_3 = _a.sent();
                return [2 /*return*/, Promise.reject(err_3)];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * method to get maps details based on the mapid
 * @param token {string} - authorization token
 * @param mapId - to get the maps details of
 * @returns - response data
 */
export var getMapDetails = function (token, mapId) { return __awaiter(void 0, void 0, void 0, function () {
    var listUrl, response, err_4;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                listUrl = getListIndoorMapsUrl() + "/" + mapId;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.get(listUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 2:
                response = _b.sent();
                return [2 /*return*/, response || null];
            case 3:
                err_4 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_4 === null || err_4 === void 0 ? void 0 : err_4.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * method to get the filtered list of maps based on the search text
 * @param token {string} - authorization token
 * @param searchText {string} - text to get the list on basis of
 * @returns - response data
 */
export var getFilteredIndoorMaps = function (token, searchText) { return __awaiter(void 0, void 0, void 0, function () {
    var listUrl, paramsSearch, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                listUrl = getListIndoorMapsUrl();
                paramsSearch = "?q=" + encodeURIComponent(searchText ? searchText : "");
                listUrl = listUrl.concat(paramsSearch);
                return [4 /*yield*/, axios.get(listUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
        }
    });
}); };
/**
 * method to get collection present in the realm
 * @param token {string} - authorization token
 * @returns - response data or error status
 */
export var getCollections = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var collectionsUrl, response, err_5;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                collectionsUrl = getCollectionsUrl();
                return [4 /*yield*/, axios.get(collectionsUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
            case 2:
                err_5 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_5 === null || err_5 === void 0 ? void 0 : err_5.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to know whether the maps is present in default collection or not
 * using collectionHRN and snapshotTime
 * @param token {string} - authorization token
 * @param collectionHRN {string} - the collection to download data from
 * @param indoorMapID - {string} - mapid to check for
 * @returns - response data or error status
 */
export var getMapsPublishedStatus = function (token, collectionHRN, indoorMapID) { return __awaiter(void 0, void 0, void 0, function () {
    var layersUrl;
    var _a;
    return __generator(this, function (_b) {
        try {
            layersUrl = getLayersUrl() +
                "/" +
                collectionHRN +
                "/layers/9999999999999/search?p.indoorMapId=" +
                indoorMapID;
            return [2 /*return*/, axios.get(layersUrl, {
                    headers: {
                        Authorization: "Bearer ".concat(token),
                    },
                })];
        }
        catch (err) {
            return [2 /*return*/, Promise.reject((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data.status)];
        }
        return [2 /*return*/];
    });
}); };
/**
 * method to create snapshot for the collection using collectionHRN
 * @param token {string} - authorization token
 * @param collectionHRN {string} - the collection to which snapshot will be posted
 * @returns - response data or error status
 */
export var postSnapshots = function (token, collectionHRN) { return __awaiter(void 0, void 0, void 0, function () {
    var collectionsUrl, snapshotUrl, response, err_6;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                collectionsUrl = getCollectionsUrl();
                snapshotUrl = collectionsUrl + "/" + collectionHRN + "/snapshots";
                return [4 /*yield*/, axios.post(snapshotUrl, null, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
            case 2:
                err_6 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_6 === null || err_6 === void 0 ? void 0 : err_6.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to refresh default layer (9999999999999)
 * @param token {string} - authorization token
 * @param collectionHRN {string} - the collection to which snapshot will be posted
 * @returns - response data or error status
 */
export var refreshDefaultLayer = function (token, collectionHRN) { return __awaiter(void 0, void 0, void 0, function () {
    var collectionsUrl, snapshotUrl, response, err_7;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                collectionsUrl = getCollectionsUrl();
                snapshotUrl = collectionsUrl +
                    "/" +
                    collectionHRN +
                    "/snapshots/2286-11-20T17:46:39.999Z";
                return [4 /*yield*/, axios.put(snapshotUrl, null, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
            case 2:
                err_7 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_7 === null || err_7 === void 0 ? void 0 : err_7.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to download entire data present in the collection from the IML layer
 * using collectionHRN and layerId
 * @param token {string} - authorization token
 * @param collectionHRN {string} - the collection to download data from
 * @param layerId {string} - layer to download data from
 * @param dispatch - to set the value of StepIndex
 * @returns - response data or error status
 */
export var getAllCollectionData = function (token, collectionHRN, layerId, dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var layersUrl, response, err_8;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                layersUrl = getLayersUrl();
                layersUrl =
                    layersUrl +
                        "/" +
                        collectionHRN +
                        "/layers/" +
                        layerId.toString() +
                        "/iterate";
                return [4 /*yield*/, axios.get(layersUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                        onDownloadProgress: function (progressEvent) {
                            var progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                            dispatch(setStepIndex(progress));
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
            case 2:
                err_8 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_8 === null || err_8 === void 0 ? void 0 : err_8.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to download entire data present in the collection from the IML layer
 * using collectionHRN and layerId
 * @param token {string} - authorization token
 * @param draftHRN {string} - the collection to download data from
 * @param layerId {string} - layer to download data from
 * @param dispatch - to set the value of StepIndex
 * @returns - response data or error status
 */
export var getMomFromIML = function (token, draftHRN) { return __awaiter(void 0, void 0, void 0, function () {
    var layersUrl, response, err_9;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                layersUrl = getLayersUrl();
                layersUrl = layersUrl + "/" + draftHRN + "/layers/imc-layer-wip/iterate";
                return [4 /*yield*/, axios.get(layersUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
            case 2:
                err_9 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_9 === null || err_9 === void 0 ? void 0 : err_9.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to get no of maps in the snapshot
 * using collectionHRN and snapshotTime
 * @param token {string} - authorization token
 * @param collectionHRN {string} - the collection to download data from
 * @param   snapshotTime {string} - snapshot to get data from
 * @param dispatch - to set the value of StepIndex
 * @returns - response data or error status
 */
export var getIndoorSiteInSnapshot = function (token, collectionHRN, snapshotTime) { return __awaiter(void 0, void 0, void 0, function () {
    var layersUrl, response, err_10;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                layersUrl = getLayersUrl();
                layersUrl =
                    layersUrl +
                        "/" +
                        collectionHRN +
                        "/layers/" +
                        snapshotTime +
                        "/search?p.featureType=indoor.Site";
                return [4 /*yield*/, axios.get(layersUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
            case 2:
                err_10 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_10 === null || err_10 === void 0 ? void 0 : err_10.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to post migration form data for the particular venue using venue id
 * @param token {string} - authorization token
 * @param venue - data to be migrated for the venue
 * @returns - response data or error status
 */
export var postMigrateMap = function (token, venue) { return __awaiter(void 0, void 0, void 0, function () {
    var listUrl, response, err_11;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                listUrl = getListIndoorMapsUrl() + "/" + venue.id;
                return [4 /*yield*/, axios.put(listUrl, JSON.stringify(venue), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response];
            case 2:
                err_11 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_11 === null || err_11 === void 0 ? void 0 : err_11.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to get all the drafts
 * @param token {string} - authorization token
 * @returns - response data or error status
 */
export var getDrafts = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var draftsUrl, response, err_12;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                draftsUrl = getDraftsUrl();
                return [4 /*yield*/, axios.get(draftsUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
            case 2:
                err_12 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_12 === null || err_12 === void 0 ? void 0 : err_12.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to get draft by HRN
 * @param token {string} - authorization token
 * @param draftHRN {string} - draft HRN
 * @returns - response data or error status
 */
export var getDraftByHRN = function (token, draftHRN) { return __awaiter(void 0, void 0, void 0, function () {
    var draftsUrl, response, err_13;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                draftsUrl = getDraftsUrl() + "/" + draftHRN;
                return [4 /*yield*/, axios.get(draftsUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
            case 2:
                err_13 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_13 === null || err_13 === void 0 ? void 0 : err_13.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to draft state
 * @param token {string} - authorization token
 * @param draftHrn {string} - draft to get state of
 * @returns - response data or error status
 */
export var getDraftState = function (token, draftHrn) { return __awaiter(void 0, void 0, void 0, function () {
    var draftsUrl;
    var _a;
    return __generator(this, function (_b) {
        try {
            draftsUrl = getDraftsUrl() + "/" + draftHrn + "/state";
            return [2 /*return*/, axios.get(draftsUrl, {
                    headers: {
                        Authorization: "Bearer ".concat(token),
                    },
                })];
        }
        catch (err) {
            return [2 /*return*/, Promise.reject((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data.status)];
        }
        return [2 /*return*/];
    });
}); };
/**
 * currently not in use, keeping it for future reference
 * method to check whether the drafts exists or not for the map using indoor map id
 * @param token {string} - authorization token
 * @param indoorMapID  {string} - id to check against
 * @returns - response data or error status
 */
export var checkDraftExists = function (token, indoorMapID, realm, envId) { return __awaiter(void 0, void 0, void 0, function () {
    var draftsUrl, response, err_14;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                draftsUrl = getDraftsUrl();
                draftsUrl =
                    draftsUrl +
                        "/" +
                        "hrn:" +
                        envId +
                        ":data::" +
                        realm +
                        ":" +
                        indoorMapID +
                        "-draft";
                return [4 /*yield*/, axios.head(draftsUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response || null];
            case 2:
                err_14 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_14 === null || err_14 === void 0 ? void 0 : err_14.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to update draft for the map using indoor map id
 * @param token {string} - authorization token
 * @param draftOrder {Object} - indoorMapId and draftType are required in payload
 * @returns - response data or error status
 */
export var updateDrafts = function (token, draftBody) { return __awaiter(void 0, void 0, void 0, function () {
    var draftsUrl, response, err_15;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                draftsUrl = getDraftsUrl();
                return [4 /*yield*/, axios.post(draftsUrl, JSON.stringify(draftBody), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                err_15 = _a.sent();
                return [2 /*return*/, Promise.reject(err_15)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to delete draft using draftHrn
 * @param token {string} - authorization token
 * @param draftHrn {string} - id to delete map against
 * @returns - response data or error status
 */
export var deleteDrafts = function (token, draftHrn) { return __awaiter(void 0, void 0, void 0, function () {
    var draftsUrl, response, err_16;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                draftsUrl = getDraftsUrl();
                draftsUrl = draftsUrl + "/" + draftHrn;
                return [4 /*yield*/, axios.delete(draftsUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                err_16 = _a.sent();
                return [2 /*return*/, Promise.reject(err_16)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to delete map using mapid
 * @param token {string} - authorization token
 * @param mapId {string} - id to delete map against
 * @returns - response data or error status
 */
export var deleteMaps = function (token, mapId) { return __awaiter(void 0, void 0, void 0, function () {
    var mapsUrl, response, err_17;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                mapsUrl = getListIndoorMapsUrl();
                mapsUrl = mapsUrl + "/" + mapId;
                return [4 /*yield*/, axios.delete(mapsUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                err_17 = _a.sent();
                return [2 /*return*/, Promise.reject(err_17)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to check-in map
 * @param token {string} - authorization token
 * @param draftsHrn {string} - id to update draft against
 * @returns - response data or error status
 */
export var postDraftStatus = function (token, draftsHrn, state) { return __awaiter(void 0, void 0, void 0, function () {
    var draftsUrl, response, err_18;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                draftsUrl = getDraftsUrl();
                draftsUrl = draftsUrl + "/" + draftsHrn + "/state";
                return [4 /*yield*/, axios.post(draftsUrl, JSON.stringify({
                        draftState: state,
                    }), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                err_18 = _a.sent();
                return [2 /*return*/, Promise.reject(err_18)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method post new draft order
 * @param token {string} - authorization token
 * @param draftsHrn {string} - id to update draft against
 * @returns - response data or error status
 */
export var postDrafts = function (token, mapOrderObj) { return __awaiter(void 0, void 0, void 0, function () {
    var draftUrl, encodedURL, response, err_19;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                draftUrl = getDraftsUrl();
                encodedURL = encodeURI("".concat(draftUrl));
                return [4 /*yield*/, axios.post(encodedURL, JSON.stringify(mapOrderObj), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                err_19 = _a.sent();
                return [2 /*return*/, Promise.reject(err_19 === null || err_19 === void 0 ? void 0 : err_19.response)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 *method to get sorted list of maps based on the sort parameter
 * @param token {string} - authorization token
 * @param searchText - to sort list based on
 * @returns - response data
 */
export var getSortedIndoorMaps = function (token, searchText) { return __awaiter(void 0, void 0, void 0, function () {
    var listUrl, paramsSearch, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                listUrl = getListIndoorMapsUrl();
                paramsSearch = "?sort=" + encodeURIComponent(searchText);
                listUrl = listUrl.concat(paramsSearch);
                return [4 /*yield*/, axios.get(listUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
        }
    });
}); };
/**
 * method to get the list of url in the desc order of the creation time
 * @param token {string} - authorization token
 * @returns - response data or error status
 */
export var getCatalogHRN = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var catalogUrl, response, err_20;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                catalogUrl = getCatalogUrl();
                return [4 /*yield*/, axios.get(catalogUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                        params: {
                            verbose: "true",
                            q: "-maps",
                            sortBy: "created",
                            sortOrder: "desc",
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
            case 2:
                err_20 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_20 === null || err_20 === void 0 ? void 0 : err_20.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to post data for MOM conversion specifying catalogHRN
 * @param token {string} - authorization token
 * @param venueid - id the data to be posted for
 * @param venueName - name the data to be posted on
 * @returns - response data or error status
 */
export var postMice2Mom = function (token, migrateMapObj) { return __awaiter(void 0, void 0, void 0, function () {
    var mice2MoMUrl, response, err_21;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                mice2MoMUrl = getDraftsUrl();
                return [4 /*yield*/, axios.post(mice2MoMUrl, JSON.stringify(migrateMapObj), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response];
            case 2:
                err_21 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_21 === null || err_21 === void 0 ? void 0 : err_21.response) === null || _a === void 0 ? void 0 : _a.data)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to get checkin report for collection
 * @param token {string} - authorization token
 * @param hrn {string} - collection hrn
 * @param snapshotTime {string} - latest snapshot
 * @returns - response data or error status
 */
export var viewCheckinReport = function (token, hrn, snapshotTime) { return __awaiter(void 0, void 0, void 0, function () {
    var reportUrl, response, err_22;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                reportUrl = getBlobStoreUrl() +
                    "/" +
                    hrn +
                    "/layers/reports/keys/" +
                    snapshotTime.toString();
                return [4 /*yield*/, axios.get(reportUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
            case 2:
                err_22 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_22 === null || err_22 === void 0 ? void 0 : err_22.response) === null || _a === void 0 ? void 0 : _a.data)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to check whether the QA Report exists or not
 * @param token {string} - authorization token
 * @param collectionHRN  {string} - id to check against
 * @returns - response data or error status
 */
export var checkQAReportExists = function (token, collectionHRN) { return __awaiter(void 0, void 0, void 0, function () {
    var qaReportUrl, response, err_23;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                qaReportUrl = "".concat(getBlobStoreUrl(), "/").concat(collectionHRN, "/layers/reports/keys/qa");
                return [4 /*yield*/, axios.head(qaReportUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                err_23 = _a.sent();
                return [2 /*return*/, Promise.reject(err_23)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to get the QA Report
 * @param token {string} - authorization token
 * @param collectionHRN  {string} - id to check against
 * @returns - response data or error status
 */
export var getQAReport = function (token, collectionHRN) { return __awaiter(void 0, void 0, void 0, function () {
    var qaReportUrl, response, err_24;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                qaReportUrl = "".concat(getBlobStoreUrl(), "/").concat(collectionHRN, "/layers/reports/keys/qa");
                return [4 /*yield*/, axios.get(qaReportUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response || null];
            case 2:
                err_24 = _a.sent();
                return [2 /*return*/, Promise.reject(err_24)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var postAttachmentToSNOW = function (token, hrn, file) { return __awaiter(void 0, void 0, void 0, function () {
    var baseUrl, formData, response;
    var _a, _b;
    return __generator(this, function (_c) {
        baseUrl = "".concat(getDraftsUrl(), "/").concat(hrn, "/attachments");
        try {
            formData = new FormData();
            formData.append("file", file);
            response = axios.put(baseUrl, formData, {
                headers: {
                    Authorization: "Bearer ".concat(token),
                    "Content-Type": "multipart/form-data",
                },
            });
            return [2 /*return*/, response];
        }
        catch (err) {
            return [2 /*return*/, Promise.reject((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.status)];
        }
        return [2 /*return*/];
    });
}); };
/**
 * method to get the map version data
 * @param token {string} - authorization token
 * @param indoorCatalogHrn {string} - catalogHrn for getting map version data
 * @returns - response data or error status
 */
export var getMapVersion = function (token, indoorCatalogHrn) { return __awaiter(void 0, void 0, void 0, function () {
    var metaDataUrl, response, err_25;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                metaDataUrl = "".concat(getMetaDataUrl(), "/").concat(indoorCatalogHrn, "/versions/latest?startVersion=0");
                return [4 /*yield*/, axios.get(metaDataUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                err_25 = _a.sent();
                return [2 /*return*/, Promise.reject(err_25)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to get the map partition data
 * @param token {string} - authorization token
 * @param indoorCatalogHrn {string} - catalogHrn for getting map version data
 * @param version {string} - partition version
 * @returns - response data or error status
 */
export var getMapPartition = function (token, indoorCatalogHrn, version) { return __awaiter(void 0, void 0, void 0, function () {
    var metaDataUrl, response, err_26;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                metaDataUrl = "".concat(getMetaDataUrl(), "/").concat(indoorCatalogHrn, "/layers/models/partitions?version=").concat(version);
                return [4 /*yield*/, axiosGetAPI(metaDataUrl, token)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                err_26 = _a.sent();
                return [2 /*return*/, Promise.reject(err_26)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to get the map mom data
 * @param token {string} - authorization token
 * @param indoorCatalogHrn {string} - catalogHrn for getting map version data
 * @param version {string} - partition version
 * @returns - response data or error status
 */
export var getMapMomData = function (token, indoorCatalogHrn, venueIdIncludedPartitionLayer, venueIdIncludedPartitionDataHandle) { return __awaiter(void 0, void 0, void 0, function () {
    var metaDataUrl, response, err_27;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                metaDataUrl = "".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_BLOBSTORE_URL, "/v1/catalogs/").concat(indoorCatalogHrn, "/layers/").concat(venueIdIncludedPartitionLayer, "/data/").concat(venueIdIncludedPartitionDataHandle);
                return [4 /*yield*/, axios.get(metaDataUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                        responseType: "arraybuffer",
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response];
            case 2:
                err_27 = _b.sent();
                return [2 /*return*/, Promise.reject(err_27)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to get the map svg data
 * @param token {string} - authorization token
 * @param defaultCollectionHrn {string} - catalogHrn for getting map version data
 * @returns - response data or error status
 */
export var getMapSvg = function (token, defaultCollectionHrn) { return __awaiter(void 0, void 0, void 0, function () {
    var metaDataUrl, response, err_28;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                metaDataUrl = "".concat(getLayersUrl(), "/").concat(defaultCollectionHrn, "/layers/icons/features/svg");
                return [4 /*yield*/, axiosGetAPI(metaDataUrl, token)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                err_28 = _a.sent();
                return [2 /*return*/, Promise.reject(err_28)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * method to get the map themerule data
 * @param token {string} - authorization token
 * @param defaultCollectionHrn {string} - catalogHrn for getting map version data
 * @returns - response data or error status
 */
export var getMapTheme = function (token, defaultCollectionHrn) { return __awaiter(void 0, void 0, void 0, function () {
    var metaDataUrl, response, err_29;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                metaDataUrl = "".concat(getLayersUrl(), "/").concat(defaultCollectionHrn, "/layers/config/features/indoorMapRules");
                return [4 /*yield*/, axiosGetAPI(metaDataUrl, token)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
            case 2:
                err_29 = _a.sent();
                return [2 /*return*/, Promise.reject(err_29)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var listVenueRequests = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_30;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_CUSTOMER_ONBOARDING_URL, "/v0/indoor-map-orders"), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _c.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
            case 2:
                err_30 = _c.sent();
                return [2 /*return*/, Promise.reject((_b = err_30 === null || err_30 === void 0 ? void 0 : err_30.response) === null || _b === void 0 ? void 0 : _b.data)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var postVenueRequest = function (token, venue) { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_31;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.post("".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_CUSTOMER_ONBOARDING_URL, "/v0/indoor-map-orders"), JSON.stringify(venue), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _b.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
            case 2:
                err_31 = _b.sent();
                return [2 /*return*/, Promise.reject()];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var listMapMigrationRequests = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var response, indoorMapMigrationRequests, e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_CUSTOMER_ONBOARDING_URL, "/v0/indoor-map-migrations"), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _b.sent();
                indoorMapMigrationRequests = (response === null || response === void 0 ? void 0 : response.data).indoorMapMigrationRequests;
                return [2 /*return*/, Promise.resolve(indoorMapMigrationRequests)];
            case 2:
                e_1 = _b.sent();
                return [2 /*return*/, Promise.reject(e_1.stack)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getMapMigrationDetails = function (token, indoorMapRequestId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, data, indoorMapMigrationRequest, e_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_CUSTOMER_ONBOARDING_URL, "/v0/indoor-map-migrations/").concat(indoorMapRequestId), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _b.sent();
                if ((response === null || response === void 0 ? void 0 : response.status) != 200) {
                    data = response.data;
                    return [2 /*return*/, Promise.reject(data)];
                }
                indoorMapMigrationRequest = response.data.indoorMapMigrationRequest;
                return [2 /*return*/, Promise.resolve(indoorMapMigrationRequest)];
            case 2:
                e_2 = _b.sent();
                return [2 /*return*/, Promise.reject(e_2.stack)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getMapMigrationJobs = function (token, indoorMapRequestId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, data, indoorMapRequestJobs, e_3;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get("".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_CUSTOMER_ONBOARDING_URL, "/v0/indoor-map-migrations/").concat(indoorMapRequestId, "/jobs"), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _b.sent();
                if ((response === null || response === void 0 ? void 0 : response.status) != 200) {
                    data = response.data;
                    return [2 /*return*/, Promise.reject(data)];
                }
                indoorMapRequestJobs = (response === null || response === void 0 ? void 0 : response.data).indoorMapRequestJobs;
                return [2 /*return*/, Promise.resolve(indoorMapRequestJobs)];
            case 2:
                e_3 = _b.sent();
                return [2 /*return*/, Promise.reject(e_3.stack)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var postMapMigrationJobsReset = function (token, indoorMapRequestId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, data, indoorMapRequestJobs, err_32;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.post("".concat(window === null || window === void 0 ? void 0 : window.app.REACT_APP_VENUE_CUSTOMER_ONBOARDING_URL, "/v0/indoor-map-migrations/").concat(indoorMapRequestId, "/reset-jobs"), JSON.stringify({
                        indoorMapRequestId: indoorMapRequestId,
                    }), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _a.sent();
                if ((response === null || response === void 0 ? void 0 : response.status) != 200) {
                    data = response.data;
                    return [2 /*return*/, Promise.reject(data)];
                }
                indoorMapRequestJobs = (response === null || response === void 0 ? void 0 : response.data).indoorMapRequestJobs;
                return [2 /*return*/, Promise.resolve(indoorMapRequestJobs)];
            case 2:
                err_32 = _a.sent();
                return [2 /*return*/, Promise.reject(err_32 === null || err_32 === void 0 ? void 0 : err_32.stack)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var postMapMigrationRequest = function (token, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, data_1, indoorMapMigrationRequest, err_33;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.post("".concat((_a = window === null || window === void 0 ? void 0 : window.app) === null || _a === void 0 ? void 0 : _a.REACT_APP_VENUE_CUSTOMER_ONBOARDING_URL, "/v0/indoor-map-migrations"), JSON.stringify(__assign(__assign({}, data), { isPrivate: true })), {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json",
                        },
                    })];
            case 1:
                response = _c.sent();
                if ((response === null || response === void 0 ? void 0 : response.status) != 202) {
                    data_1 = response.data;
                    return [2 /*return*/, Promise.reject(data_1)];
                }
                indoorMapMigrationRequest = response === null || response === void 0 ? void 0 : response.data;
                return [2 /*return*/, Promise.resolve(indoorMapMigrationRequest)];
            case 2:
                err_33 = _c.sent();
                return [2 /*return*/, Promise.reject((_b = err_33 === null || err_33 === void 0 ? void 0 : err_33.response) === null || _b === void 0 ? void 0 : _b.data)];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var venueId2indoorMapId = function (legacyVenueId) {
    if (legacyVenueId.toString().length > 12) {
        throw new Error("Legacy venue id must not be longer than 12 digits!");
    }
    return "indoormap-00000000-0000-4000-a000-".concat(legacyVenueId.padStart(12, "0"));
};
/**
 * get map metadata for the given map id
 * @param token
 * @param mapId
 * @returns map metadata
 */
export var fetchMapMetaData = function (token, mapId) { return __awaiter(void 0, void 0, void 0, function () {
    var baseUrl, response, err_34;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                baseUrl = "".concat(getListIndoorMapsUrl(), "/").concat(mapId);
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios.get(baseUrl, {
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 2:
                response = _b.sent();
                return [2 /*return*/, response.data];
            case 3:
                err_34 = _b.sent();
                return [2 /*return*/, Promise.reject((_a = err_34 === null || err_34 === void 0 ? void 0 : err_34.response) === null || _a === void 0 ? void 0 : _a.data.status)];
            case 4: return [2 /*return*/];
        }
    });
}); };
